<div
  class="select select__single-line"
  [class.advancedFilterUserInput--active]="dropdown.visible && dropdown.buttonId === buttonId"
  #userPicker
  [id]="buttonId"
  [attr.data-test]="'createdByInput'"
  (click)="toggleAddUserDropdown()"
>
  <div class="select__content" #userList>
    <ng-container selected class="select__content--wrapper">
      <div class="select__content--wrapper" data-test="userPickerUsers">
        @for (userId of ppSelectedUsers; track userId) {
          <pp-user-chip
            [ppUserId]="userId"
            (ppRemoveUserCallback)="removeUserCallback($event)"
          ></pp-user-chip>
        }

        @if (!ppSelectedUsers?.length) {
          <div class="placeholder-text">
            {{ 'select_users' | ppTranslate }}
          </div>
        }
      </div>
    </ng-container>
  </div>

  @if (!ppDisabled) {
    <div class="select__caret">
      <div class="select__icon-container">
        <pp-icon
          [ppSrc]="
            dropdown.visible && dropdown.buttonId === buttonId
              ? EIconPath.ICON_MISC_UP_ARROW_18
              : EIconPath.ICON_MISC_DOWN_ARROW_18
          "
          ppColor="grey-400"
          ppClass="setSize18"
        ></pp-icon>
      </div>
    </div>
  }
</div>
